import { ColorProps } from '@chakra-ui/react';
import { Flex } from '../../../layout/flex';
import { ToastProps } from '../toast.types';

export function ToastAction({
  action,
  color
}: {
  action: ToastProps['action'];
  color: ColorProps['color'];
}): JSX.Element | null {
  if (!action) {
    return null;
  }
  return (
    <Flex
      color={color}
      mr="0.5rem"
      fontWeight="semibold"
      as="button"
      onClick={action.click}
    >
      {action.label}
    </Flex>
  );
}
